<ng-template #titleTemplate>
  <ui-icon uiType="close"></ui-icon>
  Title
</ng-template>
<ng-template #contentTemplate>
  <ui-icon uiType="check"></ui-icon>
  Content
</ng-template>
<button ui-button buttonType="primary" ui-popover [uiTrigger]="'click'" [uiTitle]="titleTemplate" [uiContent]="contentTemplate" [(uiVisible)]="visible" (uiVisibleChange)="change($event)">
  Template Rendered Click Popover
</button>

<button ui-button buttonType="primary" ui-popover [uiTrigger]="'hover'" uiTitle="Some Title" uiContent="Some Content">Text Rendered Hover Popover</button>
